<template>
  <h3 class="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wide mb-1"><slot /></h3>
</template>
